import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { HelpButtonComponent } from '../help-button/help-button.component';
import { SidebarStateService } from '../../services/sidebar-state.service';
import { EnumCacheService } from '../../services/enum-cache.service';

const COLLAPSE_BREAKPOINT = 1024;

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [RouterOutlet, SidebarComponent, HelpButtonComponent],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  constructor(
    protected readonly sidebarState: SidebarStateService,
    enumCache: EnumCacheService,
  ) {
    enumCache.ensureLoaded();
  }

  ngOnInit(): void {
    this.applyBreakpoint(window.innerWidth);
  }

  ngOnDestroy(): void {}

  @HostListener('window:resize')
  onResize(): void {
    this.applyBreakpoint(window.innerWidth);
  }

  private applyBreakpoint(width: number): void {
    if (width <= COLLAPSE_BREAKPOINT) {
      this.sidebarState.collapse();
    } else {
      this.sidebarState.expand();
    }
  }
}
